<template>
    <div class="job-summary">
        <div class="row">
            <div class="col s12 center-align">
                <h4>Job summary</h4>
            </div>
        </div>
        <div class="row">
            <div class="col s7">Restricted faces:</div>
            <div class="col s5" v-if="config.RestrictedFaces.length > 0">Has restricted faces</div>
            <div class="col s5" v-else>No restrictions</div>
        </div>
        <div class="row">
            <div class="col s7">Orientation constraints for optimization, (x, y ,z):</div>
            <div class="col s5" v-if="config.AngleRestriction.length > 0">
                {{config.AngleRestriction[0]}}, {{config.AngleRestriction[1]}}, {{config.AngleRestriction[2]}}
            </div>
            <div class="col s5" v-else>No restrictions</div>
        </div>
        <div class="row">
            <div class="col s7">Powder thickness:</div>
            <div class="col s5">{{config.layerThickness[0]}} µm</div>
        </div>
        <div class="row">
            <div class="col s7">Top support tooth width:</div>
            <div class="col s5">{{config.Wt[0]}} mm</div>
        </div>
        <div class="row">
            <div class="col s7">Bottom support tooth width:</div>
            <div class="col s5">{{config.Wb[0]}} mm</div>
        </div>
        <div class="row">
            <div class="col s7">Support density:</div>
            <div class="col s5">{{parseInt(config.fraction_avg[0] * 100)}}%</div>
        </div>
        <div class="row">
            <div class="col s7">Printer:</div>
            <div class="col s5">{{config.printer}}</div>
        </div>
        <div class="row">
            <div class="col s7">Material:</div>
            <div class="col s5">{{config.material_name}}</div>
        </div>
        <div class="row">
            <div class="col s7">STL Unit of Measure:</div>
            <div class="col s5">{{config.unit}}</div>
        </div>
        <div class="row">
            <div class="col s7">Element Size:</div>
            <div class="col s5">{{config.elementsize[0] * 1000}} mm</div>
        </div>
        <div class="row">
            <div class="col s7">Z-offset (distance from build plate):</div>
            <div class="col s5">{{config.hsub[0]}} mm</div>
        </div>
        <div class="row">
            <div class="col s7 input-field-label">Job Description:</div>
            <div class="col s5 input-field">
                <input id="jobDescription" v-model="jobDescriptionData" type="text">
            </div>
        </div>
        <div class="row">
            <div class="col s12 center-align">
                <button class="a3d btn" @click="submitData()">Submit</button>
                <button class="a3d btn inv" @click="hideSummary()">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'JobSummary',
    props: ['config', 'jobDescription', 'submit'],
    data () {
      return {
        jobDescriptionData: ''
      }
    },
    methods: {
      hideSummary () {
        this.$modal.hide('summarymodal')
      },
      submitData () {
        this.$modal.hide('summarymodal')
        this.submit(this.jobDescriptionData)
      }
    },
    created () {
      this.jobDescriptionData = this.jobDescription
    }
  }
</script>

<style lang="scss" scoped>
.job-summary {
    padding: 0 24px;
    .input-field-label {
        padding-top: 14px;
    }
    .input-field {
        margin: 0;
        input {
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// JobSummary.vue?362f6d1f